import { useEffect } from 'react'

import i18next from 'i18next'

import { getUser } from 'src/axious/user'
import { handleAxiosError } from 'src/utils/errorHandling'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

export const useAuth = () => {
  const setUser = useGlobalStore((store) => store.setUser)
  const user = useGlobalStore((store) => store.user)

  useEffect(() => {
    const getUserFn = async () => {
      if (!user) {
        try {
          const { data } = await getUser()
          setUser(data)
          if (localStorage.getItem('language_code') === '') {
            i18next.changeLanguage(data.language_code)
            localStorage.setItem('redirectByLink', '')
            localStorage.setItem('language_code', data.language_code)
          }
        } catch (error) {
          const errorMessage = handleAxiosError(error)
          console.error('Failed to get user:', errorMessage)
        }
      }
    }

    getUserFn()
  }, [])
}
